import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import PostcodeSelector from 'components/cef_form/PostcodeSelector';

const HookFormPostcodeSelector = ({
  className,
  id,
  postcodeSearched,
  setPostcodeSearched,
  setPostcodeIsReset,
  addressDataModel,
  persistedData,
}) => {
  const { setValue, errors, setError, clearErrors } =
    useContext(HookFormContext);
  const [addressValues, setAddressValues] = useState({});

  // Extracts out data from internal fields based on data model passed in
  const updateAddressValues = address => {
    Object.entries(addressDataModel).forEach(([key, field]) => {
      const value = address[field];

      if (value !== null) {
        setValue(key, value);
      }
    });
  };

  useEffect(() => {
    updateAddressValues(addressValues);
  }, [addressValues]);

  return (
    <PostcodeSelector
      className={className}
      id={id}
      postcodeSearched={postcodeSearched}
      setPostcodeSearched={setPostcodeSearched}
      setPostcodeIsReset={setPostcodeIsReset}
      setAddressValues={setAddressValues}
      setValue={setValue}
      errors={errors}
      setError={setError}
      clearErrors={clearErrors}
      persistedData={persistedData}
    />
  );
};

HookFormPostcodeSelector.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  postcodeSearched: PropTypes.bool.isRequired,
  setPostcodeSearched: PropTypes.func.isRequired,
  setPostcodeIsReset: PropTypes.func.isRequired,
  dataModel: PropTypes.object,
  persistedData: PropTypes.shape({
    house_number: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    address_line_4: PropTypes.string,
    postcode: PropTypes.string,
  }),
};

export default HookFormPostcodeSelector;
